import { useEffect } from 'react';
import { useBlocker, useNavigate } from 'react-router-dom';

const PORTVILLE_ROOMS_LIST_PATH = '/admin/portville-rooms';

export function useBackToPortvilleRoomsListOnPop(enabled: boolean = true) {
  const navigate = useNavigate();

  const blocker = useBlocker(({ currentLocation, nextLocation, historyAction }) => {
    if (!enabled) return false;
    if (historyAction !== 'POP') return false;

    const currentPath = currentLocation.pathname;
    if (!currentPath.startsWith(PORTVILLE_ROOMS_LIST_PATH)) return false;
    if (currentPath === PORTVILLE_ROOMS_LIST_PATH) return false;

    const nextPath = nextLocation.pathname;
    if (nextPath.startsWith(PORTVILLE_ROOMS_LIST_PATH)) return false;

    return true;
  });

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    blocker.reset();
    navigate(PORTVILLE_ROOMS_LIST_PATH, { replace: true });
  }, [blocker, navigate]);
}

